import React from 'react'

import { useNavigate } from 'react-router-dom'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/shared/components/molecules/Dialog/dialog'

interface ProfileIncompleteBannerProps {
	isOpen: boolean
	onClose: () => void
}

const ProfileIncompleteBanner: React.FC<ProfileIncompleteBannerProps> = ({
	isOpen,
	onClose,
}) => {
	const { t } = useTranslation('common')
	const navigate = useNavigate()

	const handleGoToProfile = () => {
		navigate('/account?tab=brand-profile')
		onClose()
	}

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="max-w-md w-full bg-background border border-border">
				<DialogHeader>
					<DialogTitle className="text-xl font-bold text-foreground">
						{t('entities.music.profile_incomplete')}
					</DialogTitle>
				</DialogHeader>

				<div className="flex flex-col items-center justify-center gap-4 py-6 text-center">
					<p className="text-base text-muted-foreground m-0 text-left leading-normal">
						{t('entities.music.profile_incomplete_description') ||
							'Please complete your profile to request custom playlists.'}
					</p>
				</div>

				<DialogFooter className="flex gap-3">
					<Button
						type="button"
						variant="outline"
						onClick={onClose}
						className="rounded-full bg-transparent border-border text-foreground hover:bg-accent"
					>
						{t('actions.cancel')}
					</Button>
					<Button
						type="button"
						variant="default"
						onClick={handleGoToProfile}
						className="rounded-full bg-primary text-secondary hover:bg-primary/90"
					>
						{t('entities.music.complete_profile')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export default ProfileIncompleteBanner
